// Lucide icon: copy (https://lucide.dev/icons/copy)
import { Copy } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconDuplicate = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Copy />
    </IconComponentStyled>
  )
}
